import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UrlService } from '../http/url.service';

import { IAccountChat } from './account-chat';

@Injectable({
  providedIn: 'root'
})
export class ChatDataService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getChatInfo(): Observable<IAccountChat> {
    const url = this.urlService.buildServerApiUrl('Account', 'ChatInfo');

    return this.http.get<IAccountChat>(url);
  }
}
